import { Box, Button, Dialog, Divider, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useState } from "react";


import CloseIcon from '@mui/icons-material/Close';

// import {  TimerComponent } from "../../pages/marketPlace/property/investPage";

import { useSelector } from "react-redux";
import { AccInformation } from "./accInformation";
import { NoteComponent } from "./noteComponent";
import transactionServices from "../../../../services/transactionServices";
import { convertToIndianFormat } from "../../../../utils/functions";
import logsService from "../../../../services/logServices";
import { InvestorActivityEventType } from "../../../../utils/eventTypes";


export default function CompletePaymentModal({ open, handleClose = () => { }, data,paymentDetails,isFullPayment, getTransaction = () => { } }) {
    const { enqueueSnackbar } = useSnackbar();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [submitting, setSubmitting] = useState(false);
    const user = useSelector(state => state.user.data)
    const couponCode=localStorage.getItem("coupon");
    const handleSubmit = async () => {
        if (data) {
            setSubmitting(true);
            const req = await transactionServices.createTransaction({
                ...data,
                isFullPayment,
                paymentMethod: "DBT",
                coupon: couponCode ?? ""
            });
            if (req && req.success) {
                enqueueSnackbar("Success", { variant: "success" });
                getTransaction();
                handleClose();
                logsService.addLog({
                    userId: user?._id,
                    event: InvestorActivityEventType.COMMITMENT_CREATED,
                    listingId: data?.listingId
                })
            }
            else {
                if (req.data) enqueueSnackbar(req.data.message, { variant: "error" });
                else enqueueSnackbar("Something went wrong!!", { variant: "error" });
            }
            setSubmitting(false);
        }
    }

    return (
        <Dialog
            scroll="paper"
            PaperProps={{
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    maxWidth: { md: "700px !important", xs: "600px" },
                    width: { xs: "calc(100% - 24px)", sm: "calc(100% - 48px)", md: "100%" },
                    margin: { xs: "12px", sm: "24px", md: 0 },
                    borderRadius: { xs: 2, md: 1 },
                    maxHeight: { xs: "92vh", md: "calc(100vh - 96px)" },
                }
            }}
            open={open}
            onClose={handleClose}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    minHeight: 0,
                    overflow: "hidden",
                }}
            >
                <Box
                    sx={{
                        flexShrink: 0,
                        bgcolor: "background.paper",
                        px: { xs: 2, md: 3 },
                        py: { xs: 1.5, md: 2 },
                        borderBottom: "1px solid",
                        borderColor: "divider",
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                >
                    <CloseIcon onClick={handleClose} sx={{ width: 24, height: 24, color: "#000", cursor: "pointer" }} />
                </Box>

                <Box
                    sx={{
                        flex: 1,
                        minHeight: 0,
                        overflowY: "auto",
                        px: { xs: 2, md: 3 },
                        py: { xs: 2, md: 2 },
                    }}
                >
                    <Stack rowGap={2}>
                        <Box>
                            <Typography variant="body1" sx={{ fontWeight: 600 }}>Transaction Summary</Typography>
                            <Box mt={1}><Transactionsummary data={data} /></Box>
                        </Box>
                        <AccInformation />
                        <NoteComponent />
                    </Stack>
                </Box>

                <Box
                    sx={{
                        flexShrink: 0,
                        bgcolor: "background.paper",
                        px: { xs: 2, md: 3 },
                        py: { xs: 2, md: 2 },
                        borderTop: "1px solid",
                        borderColor: "divider",
                    }}
                >
                    <Box sx={{ px: { xs: 0, md: 8 } }}>
                        <Button
                            size={isMobile ? "medium" : "small"}
                            onClick={handleSubmit}
                            disabled={submitting}
                            fullWidth
                            variant="contained"
                            color="secondary"
                            sx={{ fontWeight: 600, fontSize: '16px !important', textTransform: "none" }}
                        >
                            Confirm
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Dialog>
    )
}



 function Transactionsummary({data}){
    const user = useSelector(state => state.user.data);
    const bankAccount = data?.accountSelected==="Personal"?"Personal":data?.accountSelected==="Trust"?"Trust":data?.accountSelected==="HUF"?"HUF":data.entityType==="FAMILYMEMBER"?"Personal":data?.username + "'s";
    return (
   
        <Stack spacing={"10px"} sx={{ borderRadius: 1, border: "1px solid #e1e1e1"}}>
            <Stack direction={"row"} justifyContent={"space-between"} alignItems={'center'} px={3} pt={1}  >
                <Typography variant="body2">Number of {`${data?.assetClass?.tokenName?data?.assetClass?.tokenName.toUpperCase():"FRAX"}`}</Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>{convertToIndianFormat(data?.noOfFracs ,false) || "-"}</Typography>
            </Stack>
            <Divider />
            <Stack direction={"row"} justifyContent={"space-between"} alignItems={'center'} px={3} py={0}>
                <Typography variant="body2">Amount To be Paid Now</Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>{convertToIndianFormat(data?.amtTobePaid) || "-"}</Typography>
            </Stack>
            <Divider />
            {data?.pendingAmt !== 0 &&<><Stack direction={"row"} justifyContent={"space-between"} px={3}>
                <Typography variant="body2">Payment Later</Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>{convertToIndianFormat(data?.pendingAmt) || "-"}</Typography>
            </Stack>
            <Divider /></> }
            <Stack direction={"row"} justifyContent={"space-between"} px={3}>
                <Typography variant="body2">Total Investment Amount</Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>{convertToIndianFormat(data?.amtTobePaid + data?.pendingAmt) || "-"}</Typography>
            </Stack>
            {
                !data.rightToOwnerShip && <> <Divider />
                <Stack direction={"row"} justifyContent={"space-between"} px={3}>
                <Typography variant="body2"> DLT Account</Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>{`...${data?.dltAccount?.slice(-18)} - ${data?.dltNickname}`}</Typography>
                </Stack>
                </>
            }
            <Divider />
            {user?.isHufHead && <Stack direction={"row"} justifyContent={"space-between"} px={3}  pb={1}>
                <Typography variant="body2">Bank Account</Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>{bankAccount} Account</Typography>
            </Stack>}
        </Stack >
    )
 }
